<template>
    <b-container>
        <div class="card ">
            <div class="card-header main-card">
                Precios de las compañías de bus del sistema
            </div>
            <div class="card-body">
                <div>
                    <div class="mb-1">
                        <b-dropdown
                            size="lg"
                            variant="link"
                            toggle-class="text-decoration-none"
                            class="float-right"
                            no-caret
                            right
                        >
                            <template v-slot:button-content>
                                <i class="fa fa-ellipsis-v"></i>
                            </template>
                            <b-dropdown-item>
                                <div v-b-modal="'addBusCompanyPrice'">
                                    <i class="fa fa-plus-circle mr-2 fa-fw"/> Nuevo precio
                                </div>
                                <admin-add-bus-company-price-modal />
                            </b-dropdown-item>
                        </b-dropdown>
                    </div>
                </div>
                <div>
                    <div style="margin-left: 1rem">
                        <label class="mr-sm-2" for="inline-form-custom-select-pref">Compañía</label>
                        <b-form-select v-model="companyId" @input="updateList">
                            <option :value="0">Seleccione una compañía</option>
                            <option
                                v-for="company in busCompanies"
                                :key="company.id"
                                :label="company.name"
                                :value="company.id"
                            >
                                {{ company.name }}
                            </option>
                        </b-form-select>
                    </div>
                </div>
                <div>
                    <table  class="table table-hover table-bordered table-sm mt-1">
                        <thead>
                            <tr>
                                <th scope="col" title="Compañía" style="min-width: 150px;">Compañía</th>
                                <th scope="col" title="Id interno">Id interno</th>
                                <th scope="col" title="Tipo tarifa">Tipo de tarifa</th>
                                <th scope="col" title="Inicio asientos">A partir de asientos</th>
                                <th scope="col" title="Hasta asientos">Hasta asientos</th>
                                <th scope="col" title="Precio">Precio</th>
                                <th scope="col" title="Creada">Creada</th>
                                <th scope="col" title="Actualizada">Actualizada</th>
                                <th scope="col" title="Acciones">Acciones</th>
                            </tr>
                        </thead>
                        <tbody v-if="!loadingSync && prices.length > 0">
                            <admin-bus-companies-prices-row v-for="price in prices" :key="price.id" :row="price" />
                        </tbody>
                        <tbody v-else-if="!loadingSync && prices.length == 0">
                            <tr>
                                <td colspan="8">No hay resultados</td>
                            </tr>
                        </tbody>
                        <tbody v-else>
                            <tr>
                                <td colspan="8">Actualizando el listado</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </b-container>
</template>

<script>
/* eslint-disable */
import AdminBusCompaniesPricesRow from './AdminBusCompaniesPricesRow'
import AdminAddBusCompanyPriceModal from './AdminAddBusCompanyPriceModal';

import { mapGetters } from "vuex";

export default {
    components: {
        AdminBusCompaniesPricesRow,
        AdminAddBusCompanyPriceModal
    },
    data: function () {
        return {
            loadingSync: false,
            companyId: 0,
            prices: []
        }
    },
    methods: {
        async updateList() {
            if (this.companyId == 0 ) {
                this.prices = this.busCompaniesPrices
            } else {
                this.prices = this.busCompaniesPrices.filter((price) => price.company.id == this.companyId)
            }
        }
    },
    computed: {
        ...mapGetters(["busCompaniesPrices", "busCompanies"])
    },
    watch: {
        busCompaniesPrices() {
            this.updateList()
        }
    },
    async mounted() {
        this.loadingSync = true
        await this.$store.dispatch("buscompaniesprices/retrieveBusCompaniesPrices")
        await this.$store.dispatch("buscompanies/retrieveBusCompanies")
        await this.$store.dispatch("busFareTypes/retrieveBusFareTypes")
        this.loadingSync = false
    }
}
</script>